import { useState, useEffect, useRef, useCallback } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import axios from 'axios';
import '../App.css';
import { translations } from '../translations';
import { SEOHead } from '../components/SEOHead';
import GunesliProjectFAQ, { FAQ_DATA as GUNESLI_FAQ_DATA } from '../components/GunesliProjectFAQ';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const PROJECTS_DATA = [
  {
    id: "besiktas-luxury",
    name: "Luxury Residential Project in Beşiktaş",
    location: "Şişli - Mecidiyeköy, Istanbul",
    description: "A luxury residential project combining Istanbul's historical texture and modern living, offering an exclusive lifestyle with Bosphorus view. Developed by Premium Developer.",
    highlights: [
      "175 apartments across 6 floors",
      "Bosphorus, landscape, and city views",
      "Indoor swimming pool, gym, spa",
      "24/7 security, indoor parking",
      "Walking distance to metro and ferry",
      "Turkish Citizenship eligible",
      "Residence Permit eligible"
    ],
    apartment_types: "1+1 to 6.5+1 options",
    developer: "Premium Developer",
    completion_status: "90% completed",
    video_url: "https://customer-assets.emergentagent.com/job_tourism-hub-14/artifacts/ddfmucjk_be%C5%9Fikta%C5%9F%20project.mp4",
    video_url_2: "https://customer-assets.emergentagent.com/job_25bd00d0-4489-472a-8758-d846e1c629dc/artifacts/xy1cxwzy_0310%281%29.mp4",
    poster_url: "https://customer-assets.emergentagent.com/job_47464d9f-cf49-4c35-99f5-cacc84e31d7d/artifacts/rqsyc86m_OIP.webp",
    poster_url_2: "https://customer-assets.emergentagent.com/job_a12db5e2-5d54-4572-ba20-1c07b7506faf/artifacts/o6322rmo_Referans%20Be%C5%9Fikta%C5%9F%20%283%29.jpg",
    brochure_url: "/brochures/Luxury_Residence_Besiktas_EN_RU_AR.pdf",
    pricing: "Contact for pricing"
  },
  {
    id: "nivak-florya",
    name: "Ultra Luxury Living Residences In the Heart Of District of Bakırköy",
    location: "Bakırköy, Istanbul",
    description: "A lifestyle at the level you truly deserve. A private and boutique community with nature-inspired architecture, man-made lake, and unique green landscapes. Features fully European-sourced materials and natural wood and stone throughout all residences.",
    highlights: [
      "Only 96 exclusive units",
      "Ceiling height over 3.20 meters",
      "Steps away from coastline and seaside park",
      "Adjacent to Atatürk Park",
      "Indoor swimming pool, Turkish bath, sauna",
      "Fitness center and Pilates studio",
      "Football and basketball courts",
      "Turkish Citizenship eligible",
      "Ready for delivery - June 2025"
    ],
    apartment_types: "3-bedroom (225 sqm), 4 & 5-bedroom villas with private gardens, Waterfront-style residences, 6 & 7-bedroom duplex penthouses",
    developer: "Premium Developer",
    completion_status: "Ready for delivery",
    video_url: "https://customer-assets.emergentagent.com/job_tourism-hub-14/artifacts/vu8o0aq2_0226%281%29.mp4",
    poster_url: "https://customer-assets.emergentagent.com/job_25bd00d0-4489-472a-8758-d846e1c629dc/artifacts/eg3li3pv_nivak%20florya%20eng.webp",
    brochure_url: "/brochures/Bakirkoy_Luxury_EN_RU_AR.pdf",
    pricing: "Contact for pricing"
  },
  {
    id: "tual-golyaka-kanal",
    name: "Kanal Istanbul Residences Project",
    location: "Istanbul European Side",
    description: "A low-density residential project combining modern urban living with nature-focused design. Located near the Kanal Istanbul corridor, offering strong future value potential. Government-backed developer with 70% green areas.",
    highlights: [
      "26,000 sqm land area - 70% green spaces",
      "Horizontal low-rise architecture",
      "Close to Küçükçekmece Lake",
      "Easy access to TEM Highway",
      "Outdoor swimming pool and fitness center",
      "Walking and jogging paths",
      "Private gardens and large terraces",
      "24/7 security with controlled entrance",
      "Turkish Citizenship eligible",
      "Near Channel Istanbul corridor"
    ],
    apartment_types: "2+1 to 5+1 apartments, Detached villa options",
    developer: "Premium Developer",
    completion_status: "Multiple phases in development",
    video_url: "https://customer-assets.emergentagent.com/job_tourism-hub-14/artifacts/c5hw3nxr_0226%20%281%29.mp4",
    poster_url: "https://customer-assets.emergentagent.com/job_25bd00d0-4489-472a-8758-d846e1c629dc/artifacts/2voi7avy_tual%20g%C3%B6lyaka.jpg",
    brochure_url: "https://customer-assets.emergentagent.com/job_a12db5e2-5d54-4572-ba20-1c07b7506faf/artifacts/cwmpy5w6_Kanal_IStanbul_%20Residences%20EN%20%281%29%20%281%29.pdf",
    pricing: "Contact for pricing"
  },
  {
    id: "alya-merkezefendi",
    name: "Very Central New Project Near Fatih District",
    location: "Zeytinburnu, Istanbul",
    description: "A modern residential complex in the heart of Zeytinburnu offering comfortable urban living with excellent transportation connections. Features 467 apartments across 6 floors with rich social amenities.",
    highlights: [
      "467 apartments and 15 commercial units",
      "17,928 sqm land area, 80,124 sqm construction area",
      "Indoor swimming pool, fitness gym",
      "Basketball and football courts",
      "Turkish bath, sauna, steam room",
      "Children's playgrounds and walking paths",
      "24/7 security, indoor parking",
      "650m to Cevizlibağ Metrobus (walking distance)",
      "Turkish Citizenship eligible",
      "Residence Permit eligible"
    ],
    apartment_types: "1+1, 2+1, 3+1, 4+1, Duplex",
    developer: "Premium Developer",
    completion_status: "Under construction",
    video_url: "https://customer-assets.emergentagent.com/job_a12db5e2-5d54-4572-ba20-1c07b7506faf/artifacts/yrj6gjv9_0313.mp4",
    poster_url: "https://customer-assets.emergentagent.com/job_25bd00d0-4489-472a-8758-d846e1c629dc/artifacts/x1wnvnhd_alya%20merkezefendi.jpg",
    brochure_url: "/brochures/Zeytinburnu_EN_RU_AR.pdf",
    pricing: "Contact for pricing"
  },
  {
    id: "skyland-prime",
    name: "Şişli Major Prime Skyscraper Residence",
    location: "Şişli - Maslak, Istanbul",
    description: "The tallest building complex in Turkey, located between Levent and Maslak. Designed by architect Peter Vaughan of Broadway Malyan, blending high technology with innovative architecture.",
    highlights: [
      "Tallest building complex in Turkey - 1,450 units",
      "46,000 sqm construction area",
      "Central location between Levent and Maslak",
      "VIP entrance lobby and smart home system",
      "Indoor & outdoor swimming pools",
      "Shopping mall, food court, gym",
      "Turkish bath, sauna, pilates room",
      "24/7 security, shuttle service, parking",
      "Private entrance from TEM Highway",
      "Forest & city views - Immediate delivery",
      "Turkish Citizenship eligible"
    ],
    apartment_types: "Residence & Office units",
    developer: "Premium Developer",
    completion_status: "Immediate delivery",
    video_url: "https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/g20w6lc6_0226%20%282%29%281%29.mp4",
    poster_url: "https://customer-assets.emergentagent.com/job_25bd00d0-4489-472a-8758-d846e1c629dc/artifacts/beajfbwz_SKYLAND%20%281%29.jpg",
    brochure_url: "https://customer-assets.emergentagent.com/job_a12db5e2-5d54-4572-ba20-1c07b7506faf/artifacts/h75q9kf9_%C5%9Ei%C5%9Fli_Prime%20Residence%20%26%20Office.pdf",
    pricing: "Contact for pricing"
  },
  {
    id: "tual-comfort-kanal-2",
    name: "Kanal Istanbul Project Residences 2nd",
    location: "Istanbul European Side",
    description: "A major investment opportunity located on 24,000 sqm of land in Bahçeşehir with 60% green spaces. Situated at the intersection of Istanbul Airport, Kanal Istanbul corridor, North Marmara Highway and main arterial roads. Every apartment features a balcony. Title deed ready.",
    highlights: [
      "480 apartments across 6 blocks + 20 commercial units",
      "24,000 sqm land area — 60% green spaces",
      "Küçükçekmece Lake views",
      "Every apartment has a balcony",
      "Indoor swimming pool, sauna & spa, steam room",
      "Fitness center, basketball court, children's playground",
      "Walking paths and family seating areas",
      "24/7 security with CCTV and electronic security system",
      "22 km to Istanbul New Airport",
      "4 km to Küçükçekmece Lake, 3 km to E80 Highway",
      "Near Kanal Istanbul corridor — high value growth potential",
      "Title deed ready — Delivered March 2025",
      "Turkish Citizenship eligible"
    ],
    apartment_types: "2+1 (104-130 sqm), 3+1 (163-172 sqm)",
    developer: "Premium Developer",
    completion_status: "Delivered — Title deed ready",
    video_url: "/videos/kanal-istanbul-2-combined.mp4",
    poster_url: "https://customer-assets.emergentagent.com/job_25bd00d0-4489-472a-8758-d846e1c629dc/artifacts/e5g8rwpq_tual-comfort-0-gallery-EmQnTrbO491766479374.webp",
    brochure_url: "/brochures/Kanal_Istanbul_2nd_EN_RU_AR.pdf",
    pricing: "Contact for pricing"
  },
  {
    id: "avrupa-gunesli",
    name: "Central Istanbul Metro Residences 2026",
    location: "Central Istanbul — Near Major Metro Lines",
    description: "The latest 2026 flagship residential project by a premium developer in the centre of Istanbul, minutes from major metro lines on the city's key business and investment corridor. 1,556 apartments across 11 towers with panoramic views, garden duplexes, and premium amenities including VIP wellness zones.",
    highlights: [
      "1,556 apartments + 24 commercial units across 11 towers",
      "1+1 to 4+1 layouts with panoramic and garden options",
      "Central landscaped area with reflecting pool",
      "Indoor pools, gym, sauna, Turkish bath, Pilates studio",
      "Basketball courts, football pitch, boxing zone",
      "Separate VIP wellness areas for men and women (~1,500 m²)",
      "24/7 CCTV-monitored playgrounds and security",
      "5 min to İkitelli–Ataköy metro, 5–10 min to E5 & TEM",
      "Delivery: July 2027",
      "Turkish Citizenship eligible (multiple units)"
    ],
    apartment_types: "1+1, 2+1, 3+1, 4+1",
    developer: "Premium Developer",
    completion_status: "Under construction — delivery July 2027",
    video_url: "/videos/avrupa-gunesli-combined.mp4",
    poster_url: "/videos/avrupa-gunesli-poster.jpg",
    brochure_url: "https://customer-assets.emergentagent.com/job_69f6d9a2-9928-4a45-bdbe-bb2ce971af03/artifacts/cwb66i10_Project%20Presentation-EN-.pdf",
    pricing: "From $259,000"
  },
  {
    id: "referans-beylikduzu",
    name: "European Side Prime Residences",
    location: "Istanbul European Side",
    description: "A peaceful family-oriented residential project on 31,000 sqm with 70% green areas. 709 units featuring uniquely designed landscape, city and sea views, with walking-distance access to over 300 shops, malls, hospitals, and West Istanbul Marina.",
    highlights: [
      "709 units on 31,000 sqm — 70% green areas",
      "City View, Sea View, and Landscape View options",
      "Outdoor & Indoor Swimming Pools",
      "Zen Garden, Lavender & Olive Garden",
      "Sauna, Turkish Bath (Hamam), Fitness Center",
      "Basketball Court, Playground, Kindergarten",
      "Walking distance to 300+ shops, malls, hospitals",
      "24/7 security system",
      "30 km to Istanbul Airport (45 min)",
      "5 km to Metrobus & E-5 Highway",
      "Turkish Citizenship eligible",
      "Residence Permit eligible"
    ],
    apartment_types: "2+1, 2+1 Duplex, 3+1, 3.5+1, 3+1 Duplex, 4+1, 4.5+1, 4+1 Duplex, 5+1",
    developer: "Premium Developer",
    completion_status: "Under construction",
    video_url: "https://customer-assets.emergentagent.com/job_25bd00d0-4489-472a-8758-d846e1c629dc/artifacts/x6qdni3z_0307.mp4",
    poster_url: "https://customer-assets.emergentagent.com/job_25bd00d0-4489-472a-8758-d846e1c629dc/artifacts/xaafwqvr_ref%20bey.webp",
    gallery_images: [],
    brochure_url: "/brochures/European_Side_EN_AR.pdf",
    brochure_urls: {
      en: "/brochures/European_Side_EN_AR.pdf",
      ru: "https://customer-assets.emergentagent.com/job_a12db5e2-5d54-4572-ba20-1c07b7506faf/artifacts/f13ue6bi_RUS-%20SHORT%20NOTES%20REFERANS%20BEYLI%CC%87KDU%CC%88ZU%CC%88%20%281%29%20%281%29.pdf",
      ar: "https://customer-assets.emergentagent.com/job_25bd00d0-4489-472a-8758-d846e1c629dc/artifacts/v9nl3tom_AR%20-%20REFERANS%20BEYL%C4%B0KD%C3%9CZ%C3%9C.pdf",
      tr: "https://customer-assets.emergentagent.com/job_25bd00d0-4489-472a-8758-d846e1c629dc/artifacts/o35r7elx_TR%20-%20REFERANS%20BEYL%C4%B0KD%C3%9CZ%C3%9C.pdf"
    },
    pricing: "Contact for pricing"
  }
];

function LazyVideo({ videoUrl, posterUrl, altText }) {
  const [isPlaying, setIsPlaying] = useState(false);

  if (isPlaying) {
    return (
      <video
        controls
        autoPlay
        playsInline
        preload="auto"
        webkit-playsinline="true"
        x-webkit-airplay="allow"
        controlsList="nodownload"
        className="video-player"
        data-testid="project-video-player"
        style={{ width: '100%', height: 'auto', display: 'block' }}
      >
        <source src={videoUrl} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    );
  }

  return (
    <div 
      className="video-poster-wrapper" 
      onClick={function() { setIsPlaying(true); }}
      onTouchEnd={function(e) { e.preventDefault(); setIsPlaying(true); }}
      role="button"
      tabIndex={0}
      data-testid="video-play-trigger"
      style={{ position: 'relative', cursor: 'pointer', width: '100%', paddingBottom: '56.25%', overflow: 'hidden', background: '#0f172a' }}
    >
      <img 
        src={posterUrl} 
        alt={altText} 
        className="video-poster-img" 
        style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', objectFit: 'cover', display: 'block' }}
      />
      <div style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', width: '70px', height: '70px', background: 'rgba(0,0,0,0.6)', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ width: 0, height: 0, borderStyle: 'solid', borderWidth: '12px 0 12px 22px', borderColor: 'transparent transparent transparent white', marginLeft: '4px' }}></div>
      </div>
    </div>
  );
}

const sectionBgImages = [
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/wz19565z_9c.jpg',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/wwitgywe_40.jpg',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/ukm0anx7_74.jpg',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/8elisbo1_caption%289%29.jpg',
  'https://customer-assets.emergentagent.com/job_6219a777-9ebb-4000-a873-c607f504c328/artifacts/iz9x4wud_topkap%C4%B1%20saray%C4%B1.png'
];

export default function RealEstatePage({ language, setLanguage }) {
  const t = translations[language];
  const isAr = language === 'ar';
  const location = useLocation();
  const navigate = useNavigate();

  const langText = (en, ar, ru, tr) => {
    if (language === 'ar') return ar;
    if (language === 'ru') return ru;
    if (language === 'tr') return tr;
    return en;
  };
  const projects = PROJECTS_DATA;
  const [sectionBgIndex, setSectionBgIndex] = useState(0);
  const [showInquiryModal, setShowInquiryModal] = useState(false);
  const [selectedService, setSelectedService] = useState('');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState({ text: '', type: '' });
  const [inquiryForm, setInquiryForm] = useState({ name: '', email: '', phone: '', message: '' });
  const [openDropdown, setOpenDropdown] = useState(null);
  const headerRef = useRef(null);

  useEffect(() => {
    const bgInterval = setInterval(() => {
      setSectionBgIndex((prev) => (prev + 1) % 5);
    }, 8000);
    return () => clearInterval(bgInterval);
  }, []); // setSectionBgIndex is stable

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const el = document.querySelector(location.hash);
        if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 500);
    }
  }, [location.hash, projects]);

  const handleClickOutside = useCallback((e) => {
    if (headerRef.current && !headerRef.current.contains(e.target)) {
      setOpenDropdown(null);
    }
  }, []);

  useEffect(() => {
    document.addEventListener('touchstart', handleClickOutside);
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('touchstart', handleClickOutside);
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [handleClickOutside]);

  const handleDropdownTrigger = (e, dropdownId, linkTo) => {
    if (openDropdown === dropdownId) {
      setOpenDropdown(null);
      if (linkTo) navigate(linkTo);
    } else {
      e.preventDefault();
      setOpenDropdown(dropdownId);
    }
  };

  const handleDropdownItemClick = () => {
    setOpenDropdown(null);
  };

  const openInquiryModal = (serviceType, serviceName) => {
    setSelectedService(serviceType);
    setInquiryForm({ ...inquiryForm, message: `I'm interested in ${serviceName}` });
    setShowInquiryModal(true);
  };

  const handleInquirySubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await axios.post(`${API}/inquiries`, { ...inquiryForm, service_type: selectedService });
      setMessage({ text: t.inquiry?.inquirySuccess || 'Inquiry submitted successfully!', type: 'success' });
      setInquiryForm({ name: '', email: '', phone: '', message: '' });
      setShowInquiryModal(false);
    } catch (error) {
      setMessage({ text: t.inquiry?.inquiryError || 'Error submitting inquiry.', type: 'error' });
    } finally {
      setLoading(false);
      setTimeout(() => setMessage({ text: '', type: '' }), 3000);
    }
  };

  return (
    <div className="app">
      <SEOHead
        title={language === 'ar' ? (translations.ar.seo?.realEstateTitle || 'Turkish Real Estate & Citizenship by Investment | Viaturkey') : 'Turkish Real Estate & Citizenship by Investment | Viaturkey'}
        description={language === 'ar' ? (translations.ar.seo?.realEstateDesc || '') : 'Buy luxury Istanbul property and obtain Turkish citizenship. Expert real estate consulting for GCC nationals — from property selection to Turkish passport issuance. Arabic-speaking team.'}
        canonical="https://viaturkey.net/real-estate"
        schema={{
          "@context": "https://schema.org",
          "@graph": [
            {
              "@type": "FAQPage",
              "@id": "https://viaturkey.net/real-estate#faq",
              "inLanguage": language === 'ar' ? 'ar' : language === 'ru' ? 'ru' : language === 'tr' ? 'tr' : 'en',
              "mainEntity": (GUNESLI_FAQ_DATA[language] || GUNESLI_FAQ_DATA.en).items.map(item => ({
                "@type": "Question",
                "name": item.q,
                "acceptedAnswer": { "@type": "Answer", "text": item.a }
              }))
            }
          ]
        }}
      />

      {/* Real Estate Hero */}
      <section className="page-hero realestate-page-hero">
        <div className="section-bg-carousel">
          {sectionBgImages.map((img, idx) => (
            <div key={`re-bg-${idx}-${img.slice(-15)}`} className={`section-bg-slide ${idx === ((sectionBgIndex + 2) % 5) ? 'active' : ''}`} style={{ backgroundImage: `url(${img})` }}></div>
          ))}
          <div className="page-hero-overlay"></div>
        </div>
        <div className="container page-hero-content">
          <h1>
            <span className="title-highlight">{t.realEstate.titleHighlight1}</span>{' '}
            <span className="title-highlight">{t.realEstate.titleHighlight2}</span>
          </h1>
        </div>
      </section>

      {/* Projects */}
      <section className="real-estate-section" data-testid="real-estate-section">
        <div className="container">
          {projects.map((project) => (
            <div key={project.id} className="project-showcase" id={`project-${project.id}`} data-testid={`project-${project.id}`}>
              <div className="project-video">
                <LazyVideo 
                  videoUrl={project.video_url} 
                  posterUrl={project.poster_url || ''} 
                  altText={t.projects?.[project.id]?.name || project.name}
                />
                {project.video_url_2 && (
                  <div style={{marginTop: '1rem'}}>
                    <LazyVideo 
                      videoUrl={project.video_url_2} 
                      posterUrl={project.poster_url_2 || project.poster_url || ''} 
                      altText={`${t.projects?.[project.id]?.name || project.name} - 2`}
                    />
                  </div>
                )}
              </div>
              <div className="project-details">
                <h3>{t.projects?.[project.id]?.name || project.name}</h3>
                <p className="project-location">&#128205; {t.projects?.[project.id]?.location || project.location}</p>
                <p className="project-description">{t.projects?.[project.id]?.description || project.description}</p>
                <div className="project-highlights">
                  <h4>{t.realEstate.keyFeatures}:</h4>
                  <ul>
                    {(t.projects?.[project.id]?.highlights || project.highlights).map((highlight, idx) => (
                      <li key={`hl-${project.id}-${idx}`}>&#10003; {highlight}</li>
                    ))}
                  </ul>
                </div>
                <div className="project-info">
                  <p><strong>{t.realEstate.developer}:</strong> {t.projects?.[project.id]?.developer || project.developer}</p>
                  <p><strong>{t.realEstate.status}:</strong> {t.projects?.[project.id]?.completionStatus || project.completion_status}</p>
                  <p><strong>{t.realEstate.apartmentTypes}:</strong> {t.projects?.[project.id]?.apartmentTypes || project.apartment_types}</p>
                </div>
                {/* Gallery Images */}
                {project.gallery_images && project.gallery_images.length > 0 && (
                  <div className="project-gallery" data-testid={`gallery-${project.id}`}>
                    <h4 className="project-gallery-title">{langText('Project Images', 'صور المشروع', 'Фотографии проекта', 'Proje Görselleri')}</h4>
                    <div className="project-gallery-grid">
                      {project.gallery_images.map((img, idx) => (
                        <img key={`gal-${project.id}-${idx}`} src={img} alt={`${project.name} ${idx + 1}`} className="project-gallery-img" loading="lazy" />
                      ))}
                    </div>
                  </div>
                )}
                <div className="project-actions">
                  {language === 'ar' && project.id === 'besiktas-luxury' && (
                    <div className="brochure-arabic-desc" data-testid="besiktas-arabic-desc" dir="rtl">
                      <h4>مشروع سكني فاخر في بشكتاش، إسطنبول</h4>
                      <p>يجمع هذا المشروع الفاخر، الذي يضم 175 وحدة سكنية، بين التناغم المثالي بين عبق التاريخ في إسطنبول وأسلوب الحياة العصري، موفرًا نمط حياة حصريًا في قلب بشكتاش، وسط المدينة. يرتفع المشروع تحت ظلال أشجار عمرها 200 عام، ويطل على منظر خلاب لمضيق البوسفور، ويتم تنفيذه بخبرة Premium Developer، وهي شركة مقاولات رئيسية تابعة للحكومة التركية.</p>
                      <p><strong>مزايا المشروع:</strong></p>
                      <ul>
                        <li>موقع فريد: يقع المشروع في بشكتاش، أحد أرقى أحياء إسطنبول، على بُعد خطوات من إطلالة ساحرة على مضيق البوسفور. بفضل سهولة الوصول إلى العبّارات ومحطة المترو.</li>
                        <li>تصميم معماري جمالي وعملي: يُقدّم المشروع تفسيرًا عصريًا لتاريخ بشكتاش.</li>
                        <li>مساحات معيشة خاصة: مع حدائق وتراسات واسعة، يوفر المشروع حياةً متناغمة مع الطبيعة.</li>
                        <li>مرافق اجتماعية: مساحات اجتماعية حيث يمكن للعائلات قضاء أوقات ممتعة، بالإضافة إلى أمن على مدار الساعة.</li>
                        <li>موقع مركزي: على بُعد مسافة قصيرة سيرًا على الأقدام من سوق بشكتاش التاريخي، والمدارس، والمستشفيات، ومحطة المترو.</li>
                      </ul>
                      <p><strong>ملخص المشروع:</strong></p>
                      <ul className="brochure-summary-list">
                        <li>المطور: Premium Developer</li>
                        <li>الموقع: بشكتاش، حي عباس آغا</li>
                        <li>مساحة المشروع: 17,655 متر مربع</li>
                        <li>عدد الوحدات: 175 شقة</li>
                        <li>عدد الطوابق: 6 طوابق</li>
                        <li>أنواع الشقق: 1+1 - 2+1 - 2.5+1 - 3+1 - 3.5+2 - 4+1 - 4.5+1 - 4.5+2 - 5.5+1 - 6.5+1</li>
                        <li>الإطلالات: مضيق البوسفور، والمناظر الطبيعية، والمدينة</li>
                      </ul>
                      <p><strong>المساحات الطبيعية والاجتماعية:</strong></p>
                      <ul>
                        <li>حدائق، مسابح متدرجة، ممرات للمشي، ومناطق للأنشطة</li>
                        <li>ملاعب للأطفال، مقهى، استوديوهات خاصة</li>
                        <li>مسبح داخلي، صالة رياضية نسائية، غرف استحمام، حمام تركي، ومنتجع صحي</li>
                      </ul>
                      <p><strong>الأمان والراحة:</strong> نظام أمني يعمل بالكاميرات على مدار الساعة، موقف سيارات داخلي، ومناطق تخزين</p>
                      <p><strong>المواصلات:</strong> المطار (30 دقيقة) | E-5 (2.5 كم) | حافلة (100 م)، مترو (400 م)، عبّارة (950 م)</p>
                      <p><strong>المستشفيات:</strong> مستشفى أنريكان، مستشفى أجيبادن، مستشفى ليف</p>
                      <p><strong>تعليم:</strong> جامعة إسطنبول التقنية، جامعة يلدز التقنية، جامعة بهشة شهير | مدارس MEF، مدارس إستيك، كلية روبرت</p>
                      <p><strong>المواقع الثقافية:</strong> قصور دولنبهشة وجيراجان ويلدز</p>
                      <p><strong>مراكز التسوق:</strong> بازار بشيكتاش، المركز التجاري بالمدينة، مركز زورلو</p>
                    </div>
                  )}
                  <a href={project.brochure_urls?.[language] || project.brochure_url} target="_blank" rel="noopener noreferrer" className="btn btn-secondary" data-testid="download-brochure-btn">
                    &#128196; {t.realEstate.downloadBrochure}
                  </a>
                  <div className="discovery-call-box">
                    <p className="discovery-call-text">{t.realEstate.discoveryCall}</p>
                    <a href="https://calendly.com/guzaliakin234" target="_blank" rel="noopener noreferrer" className="btn btn-primary" data-testid="project-calendly-btn">
                      {t.inquiry.bookCall || 'Book an Appointment'}
                    </a>
                  </div>
                </div>

                {/* Share Video Links */}
                <div className="project-share-icons" data-testid={`share-icons-${project.id}`}>
                  <span className="share-label">{langText('Share this project:', 'شارك المشروع:', 'Поделиться проектом:', 'Projeyi paylaş:')}</span>
                  <a href={`https://www.youtube.com/@akinguzel1490`} target="_blank" rel="noopener noreferrer" className="share-icon-btn share-youtube" data-testid={`share-yt-${project.id}`} title="YouTube">
                    <svg viewBox="0 0 24 24" fill="#FF0000" width="22" height="22"><path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814z"/><polygon fill="#fff" points="9.545,15.568 15.818,12 9.545,8.432"/></svg>
                  </a>
                  <a href={`https://www.instagram.com/via_turkey`} target="_blank" rel="noopener noreferrer" className="share-icon-btn share-instagram" data-testid={`share-ig-${project.id}`} title="Instagram">
                    <img src="https://customer-assets.emergentagent.com/job_25bd00d0-4489-472a-8758-d846e1c629dc/artifacts/x0v9k7s3_Instagram_logo_2022.svg.webp" alt="Instagram" style={{width: '24px', height: '24px', borderRadius: '6px'}} />
                  </a>
                  <a href={`https://x.com/intent/tweet?url=${encodeURIComponent(`${window.location.origin}/api/share/${project.id}?lang=${language}`)}&text=${encodeURIComponent(t.projects?.[project.id]?.name || project.name)}`} target="_blank" rel="noopener noreferrer" className="share-icon-btn share-twitter" data-testid={`share-tw-${project.id}`} title="Share on X (Twitter)">
                    <img src="https://customer-assets.emergentagent.com/job_25bd00d0-4489-472a-8758-d846e1c629dc/artifacts/cnq24vgi_fc0e73b62c1a82f2f8da18f0d96c17e8.jpg" alt={isAr ? 'إكس (تويتر)' : 'X Twitter'} style={{width: '24px', height: '24px', borderRadius: '6px'}} />
                  </a>
                  <button className="share-icon-btn share-copy" data-testid={`share-copy-${project.id}`} title={langText('Copy project link', 'نسخ رابط المشروع', 'Копировать ссылку', 'Proje linkini kopyala')} onClick={() => { const projectLink = `${window.location.origin}/api/share/${project.id}?lang=${language}`; navigator.clipboard.writeText(projectLink); const el = document.querySelector(`[data-testid="share-copy-${project.id}"]`); if(el) { el.classList.add('copied'); setTimeout(() => el.classList.remove('copied'), 1500); } }}>
                    <svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" strokeWidth="2"><rect x="9" y="9" width="13" height="13" rx="2"/><path d="M5 15H4a2 2 0 01-2-2V4a2 2 0 012-2h9a2 2 0 012 2v1"/></svg>
                  </button>
                </div>
                <div className="project-deep-link" data-testid={`deep-link-${project.id}`}>
                  <span className="deep-link-label">{langText('Social media share link:', 'رابط المشروع للمشاركة:', 'Ссылка для соцсетей:', 'Sosyal medya paylaşım linki:')}</span>
                  <code className="deep-link-url" onClick={() => { const projectLink = `${window.location.origin}/api/share/${project.id}?lang=${language}`; navigator.clipboard.writeText(projectLink); const el = document.querySelector(`[data-testid="deep-link-${project.id}"] .deep-link-url`); if(el) { el.classList.add('copied'); setTimeout(() => el.classList.remove('copied'), 1500); } }}>{`${window.location.origin}/api/share/${project.id}?lang=${language}`}</code>
                </div>

                {/* Güneşli Project FAQ */}
                {project.id === 'avrupa-gunesli' && (
                  <GunesliProjectFAQ language={language} />
                )}

                {/* Arabic Brochure for Referans */}
                {language === 'ar' && project.id === 'referans-beylikduzu' && (
                  <div className="brochure-arabic-desc" data-testid="referans-arabic-desc" dir="rtl">
                    <h4>ريفيرانس بيليك دوزو</h4>
                    <p>يقع مشروع ريفيرانس بيليك دوزو على مساحة 31,000 متر مربع، 70% منها عبارة عن مساحات خضراء ومناظر طبيعية خلابة.</p>
                    <p>ليس من المستحيل أن تعيش حياة عائلية هادئة في موقع مركزي مع تصميم فريد للمناظر الطبيعية، ومناطق اجتماعية مميزة.</p>
                    <p>إطلالات على المدينة، والبحر، والمناظر الطبيعية.</p>
                    <p>يتكون المشروع من 8 مبانٍ و709 وحدة سكنية من الأنواع التالية: شقق بغرفتي نوم وصالة، شقق دوبلكس بغرفتي نوم وصالة، شقق بثلاث غرف نوم وصالة، شقق بثلاث غرف نوم وصالة ونصف، شقق دوبلكس بثلاث غرف نوم وصالة، شقق بأربع غرف نوم وصالة، شقق بأربع غرف نوم وصالة ونصف، شقق دوبلكس بأربع غرف نوم وصالة ونصف، شقق بخمس غرف نوم وصالة</p>
                    <p><strong>المرافق الاجتماعية:</strong></p>
                    <ul>
                      <li>صالة استراحة</li>
                      <li>مسبح خارجي ومسبح داخلي</li>
                      <li>منطقة ألعاب للأطفال وملعب كرة سلة</li>
                      <li>وحدات تجارية</li>
                      <li>حديقة زن، حديقة الخزامى والزيتون</li>
                      <li>بركة/حوض تأمل</li>
                      <li>روضة أطفال وبساتين</li>
                      <li>ساونا، حمام تركي، مركز لياقة بدنية</li>
                      <li>نظام أمني يعمل على مدار الساعة</li>
                    </ul>
                    <p><strong>الموقع:</strong> أكثر من 300 متجر، ومول، ومستشفى، وصيدلية، ومطعم، ومقهى، وقاعات حفلات، ومرسى لليخوت</p>
                    <p><strong>المسافات:</strong></p>
                    <ul>
                      <li>مستشفى بيرينجي: 3 دقائق</li>
                      <li>مستشفى بيليك دوزو العام: 5 دقائق</li>
                      <li>مستشفى ميدي لايف: 5 كم</li>
                      <li>بيرلافيستا مول: 10 دقائق</li>
                      <li>جامعة جيليشيم: 10 دقائق</li>
                      <li>سوبر ماركت كارفور وميجروس: دقيقتين</li>
                      <li>مرمرة بارك مول: 5 دقائق</li>
                      <li>مرسى اسطنبول الغربي: دقيقتين</li>
                      <li>بيليك دوزو ياسام فاديسي: 5 دقائق</li>
                      <li>مطار اسطنبول: 30 كم (45 دقيقة)</li>
                      <li>المتروباص: 5 دقائق</li>
                      <li>E-5 ومتروبوس بيكنت: 5 دقائق</li>
                    </ul>
                  </div>
                )}
              </div>
            </div>
          ))}

          {/* Official Investment Resources */}
          <h3 className="official-resources-title" data-testid="official-resources-title">{t.realEstate.officialResources}</h3>
          <div className="invest-resources-grid">
            <a href="https://www.invest.gov.tr/en/investmentguide/pages/acquiring-property-and-citizenship.aspx" target="_blank" rel="noopener noreferrer" className="invest-resource-card" data-testid="invest-resource-property">
              <div className="invest-resource-img">
                <img src="https://customer-assets.emergentagent.com/job_47464d9f-cf49-4c35-99f5-cacc84e31d7d/artifacts/rqsyc86m_OIP.webp" alt={isAr ? 'تملّك العقار والحصول على الجنسية' : 'Acquiring Property and Citizenship'} loading="lazy" />
              </div>
              <div className="invest-resource-body">
                <span className="invest-source-badge">invest.gov.tr</span>
                <h4>{t.realEstate.acquiringPropertyTitle}</h4>
                <p>{t.realEstate.acquiringPropertyDesc}</p>
              </div>
            </a>
            <a href="https://www.invest.gov.tr/view?path=_en_library_publications_lists_investpublications_guide-to-foreign-citizens-acquisition-of-turkish-citizenship.pdf&view=flipbook" target="_blank" rel="noopener noreferrer" className="invest-resource-card" data-testid="invest-resource-citizenship">
              <div className="invest-resource-img">
                <img src="https://customer-assets.emergentagent.com/job_47464d9f-cf49-4c35-99f5-cacc84e31d7d/artifacts/u91i2msq_beaner_2-ok.png" alt={isAr ? 'دليل الجنسية' : 'Citizenship Guide'} loading="lazy" />
              </div>
              <div className="invest-resource-body">
                <span className="invest-source-badge">invest.gov.tr</span>
                <h4>{t.realEstate.citizenshipGuideTitle}</h4>
                <p>{t.realEstate.citizenshipGuideDesc}</p>
              </div>
            </a>
          </div>
          <div className="invest-resources-grid invest-resources-grid-3">
            <a href="https://www.invest.gov.tr/en/investmentguide/pages/obtaining-a-residence-permit.aspx" target="_blank" rel="noopener noreferrer" className="invest-resource-card" data-testid="invest-resource-residence">
              <div className="invest-resource-img">
                <img src="https://customer-assets.emergentagent.com/job_dbb6da4c-d4c7-44c6-9c82-2a61cf43263d/artifacts/q87lgz65_turkiyede-ikamet-izni-almak.jpg" alt={isAr ? 'الحصول على تصريح الإقامة' : 'Obtaining a Residence Permit'} loading="lazy" />
              </div>
              <div className="invest-resource-body">
                <span className="invest-source-badge">invest.gov.tr</span>
                <h4>{t.realEstate.residencePermitTitle}</h4>
                <p>{t.realEstate.residencePermitDesc}</p>
              </div>
            </a>
            <a href="https://www.invest.gov.tr/en/investmentguide/pages/establishing-a-business.aspx" target="_blank" rel="noopener noreferrer" className="invest-resource-card" data-testid="invest-resource-business">
              <div className="invest-resource-img">
                <img src="https://customer-assets.emergentagent.com/job_dbb6da4c-d4c7-44c6-9c82-2a61cf43263d/artifacts/z1tu66e7_lease_image.png" alt={isAr ? 'تأسيس شركة' : 'Establishing a Business'} loading="lazy" />
              </div>
              <div className="invest-resource-body">
                <span className="invest-source-badge">invest.gov.tr</span>
                <h4>{t.realEstate.establishBusinessTitle}</h4>
                <p>{t.realEstate.establishBusinessDesc}</p>
              </div>
            </a>
            <a href="https://www.invest.gov.tr/en/investmentguide/pages/obtaining-a-work-permit.aspx" target="_blank" rel="noopener noreferrer" className="invest-resource-card" data-testid="invest-resource-work-permit">
              <div className="invest-resource-img">
                <img src="https://customer-assets.emergentagent.com/job_dbb6da4c-d4c7-44c6-9c82-2a61cf43263d/artifacts/s1dmc32d_tc00493.jpg" alt={isAr ? 'الحصول على تصريح العمل' : 'Obtaining a Work Permit'} loading="lazy" />
              </div>
              <div className="invest-resource-body">
                <span className="invest-source-badge">invest.gov.tr</span>
                <h4>{t.realEstate.workPermitTitle}</h4>
                <p>{t.realEstate.workPermitDesc}</p>
              </div>
            </a>
          </div>

          <p className="more-projects">{t.realEstate.moreProjects}</p>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="container">
          <p>{t.footer.rights}</p>
          <p>{t.footer.tagline}</p>
        </div>
      </footer>

      {/* WhatsApp */}
      <a href="https://wa.me/905075337545" target="_blank" rel="noopener noreferrer" className="whatsapp-float" data-testid="whatsapp-float-btn">
        <div className="whatsapp-content">
          <svg className="whatsapp-logo" viewBox="0 0 32 32" fill="white">
            <path d="M16 0C7.164 0 0 7.164 0 16c0 2.828 0.738 5.484 2.024 7.792L0.156 31.844l8.384-2.196C10.78 30.856 13.324 31.6 16 31.6c8.836 0 16-7.164 16-16S24.836 0 16 0zm0 29.2c-2.444 0-4.748-0.668-6.712-1.832l-0.48-0.284-4.972 1.304 1.328-4.856-0.312-0.496C3.34 20.996 2.6 18.564 2.6 16 2.6 8.608 8.608 2.6 16 2.6S29.4 8.608 29.4 16 23.392 29.2 16 29.2zm7.788-10.636c-0.428-0.212-2.524-1.248-2.916-1.388-0.392-0.144-0.676-0.212-0.96 0.212-0.284 0.428-1.1 1.388-1.348 1.672-0.248 0.284-0.496 0.32-0.924 0.108-0.428-0.212-1.804-0.664-3.436-2.12-1.268-1.132-2.124-2.528-2.372-2.956-0.248-0.428-0.028-0.66 0.184-0.872 0.192-0.188 0.428-0.496 0.64-0.744 0.212-0.248 0.284-0.428 0.428-0.712 0.144-0.284 0.072-0.532-0.036-0.744-0.108-0.212-0.96-2.312-1.316-3.164-0.348-0.828-0.7-0.716-0.96-0.728-0.248-0.012-0.532-0.016-0.816-0.016s-0.744 0.108-1.132 0.532c-0.392 0.428-1.496 1.46-1.496 3.56s1.532 4.132 1.744 4.416c0.212 0.284 3 4.58 7.26 6.42 1.016 0.44 1.808 0.704 2.428 0.9 1.02 0.324 1.948 0.28 2.684 0.168 0.82-0.12 2.524-1.032 2.88-2.028 0.356-0.996 0.356-1.852 0.248-2.028-0.104-0.18-0.388-0.288-0.816-0.5z"/>
          </svg>
          <div className="whatsapp-text">
            <span className="whatsapp-label-en">{langText('Contact Us', 'تواصل معنا', 'Свяжитесь с нами', 'Bize Ulaşın')}</span>
          </div>
        </div>
      </a>

      {/* Inquiry Modal - Calendly Redirect */}
      {showInquiryModal && (
        <div className="modal-overlay" onClick={() => setShowInquiryModal(false)}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()} data-testid="inquiry-modal">
            <button className="modal-close" onClick={() => setShowInquiryModal(false)}>&times;</button>
            <h2>{t.inquiry.title}</h2>
            <p style={{ color: '#475569', marginBottom: '1.5rem', lineHeight: '1.6' }}>
              {t.realEstate.discoveryCall}
            </p>
            <a href="https://calendly.com/guzaliakin234" target="_blank" rel="noopener noreferrer" className="btn btn-primary" style={{ display: 'inline-block', textAlign: 'center', width: '100%' }} data-testid="calendly-link">
              {t.inquiry.bookCall || 'Book an Appointment'}
            </a>
          </div>
        </div>
      )}

      {message.text && (
        <div className={`toast toast-${message.type}`} data-testid="toast-message">{message.text}</div>
      )}

      {/* Floating Calendly CTA - Real Estate page */}
      <a href="https://calendly.com/guzaliakin234" target="_blank" rel="noopener noreferrer" className="floating-calendly-cta floating-calendly-left" data-testid="floating-calendly-cta-re">
        <span className="calendly-pulse"></span>
        <span className="calendly-text">{langText('15-Min Free Consultation', 'استشارة مجانية 15 دقيقة', 'Бесплатная консультация 15 мин', '15 dk Ücretsiz Danışmanlık')}</span>
      </a>
    </div>
  );
}
